import { useState } from 'react';

export default function WhatsAppFloat() {
  const [isOpen, setIsOpen] = useState(false);

  const contacts = [
    {
      name: 'Asesor Andrés',
      link: 'https://wa.me/573209769166?text=Hola, me interesa conocer más sobre sus servicios de publicidad e impresión'
    },
    {
      name: 'Asesor Karen',
      link: 'https://wa.me/message/GG6UNVA6HN5UG1'
    }
  ];

  const handleContactClick = (link: string) => {
    window.open(link, '_blank');
    setIsOpen(false);
  };

  return (
    <div className="fixed bottom-20 right-6 z-50 flex flex-col gap-2">
      {/* Panel de opciones */}
      {isOpen && (
        <div className="bg-white rounded-2xl shadow-2xl p-4 mb-2 w-64 animate-fadeIn border border-gray-100">
          <div className="flex justify-between items-center mb-3 pb-3 border-b border-gray-200">
            <h3 className="text-sm font-semibold text-gray-800">Elige un asesor</h3>
            <button
              onClick={() => setIsOpen(false)}
              className="text-gray-400 hover:text-gray-600 cursor-pointer"
              aria-label="Cerrar"
            >
              <i className="ri-close-line text-lg"></i>
            </button>
          </div>
          
          <div className="flex flex-col gap-2">
            {contacts.map((contact, index) => (
              <button
                key={index}
                onClick={() => handleContactClick(contact.link)}
                className="flex items-center gap-3 p-3 rounded-xl bg-green-50 hover:bg-green-100 transition-all duration-200 cursor-pointer group border border-green-100 hover:border-green-300"
              >
                <div className="bg-green-500 w-10 h-10 rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-200">
                  <i className="ri-whatsapp-fill text-white text-xl"></i>
                </div>
                <div className="flex flex-col items-start">
                  <span className="text-sm font-medium text-gray-800 whitespace-nowrap">{contact.name}</span>
                  <span className="text-xs text-green-600">Disponible ahora</span>
                </div>
              </button>
            ))}
          </div>
        </div>
      )}

      {/* Botón flotante */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="bg-green-500 hover:bg-green-600 text-white w-14 h-14 rounded-full shadow-lg transition-all duration-300 hover:scale-110 cursor-pointer flex items-center justify-center"
        aria-label="Contactar por WhatsApp"
      >
        <i className={`ri-${isOpen ? 'close' : 'whatsapp'}-fill text-2xl`}></i>
      </button>
    </div>
  );
}
